/* src/app/signin/signin-card/signin-card.component.scss */
app-mb-card div {
  padding: 3rem 3rem 1rem 3rem;
}
app-mb-card div > h3 {
  margin-bottom: 5rem;
}
app-mb-card div > app-mb-field {
  margin-bottom: 1rem;
}
app-mb-card div > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}
app-mb-card div > div > app-mb-button {
  flex-basis: 100%;
}
/*# sourceMappingURL=signin-card.component.css.map */
